<h2 style="display:inline-block">GPS Logs for Scenario</h2>
<button class="btn btn-danger btn-sm" style="float:right" (click)="deleteAllRecords()">Delete All Records</button>
<div class="row">
    <div class="col-md-4">
        <div *ngIf="this.overview.length == 0">This scenario has no logs for GPS records.</div>
        <table *ngIf="this.overview.length > 0" class="table table-bordered">
            <thead>
                <tr>
                    <th>Phone Session  <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('name')"></i></th>
                    <th>Count</th>
                    <th>First Date <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortGeneric(overview,'date',sortDir)"></i> </th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let b of overview">
                    <td class="link" (click)="selectByPhoneInfo(b)">{{b.name}}</td>
                    <td>{{b.count}}</td>
                    <td>{{b.date | date: 'shortDate'}}</td>
                    <td class="link" (click)="deleteSelected(b)">Delete</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-8">
        <div *ngIf="showmapheader" style="display:inline-block;">
            <h5>{{selectedScenario.scenarioname}}, {{selectedScenario.organizationname}} with phoneinfo {{phoneinfo}}</h5>
        </div>
        <button class="btn btn-primary btn-sm" (click)="showWalk()">Show Walk</button>
        <sa-input-number style="display:inline-block;max-width:150px;margin-left:10px" [(text)]="walkInterval" [title]="'Interval [ms]'" [required]="'none'"></sa-input-number>
        <sa-input-boolean style="display:inline-block;max-width:150px;margin-left:10px;margin-right:20px" [(checked)]="showAccuracy" [title]="'Show Accuracy'" [required]="'none'"></sa-input-boolean>
        <span>{{phoneinfo}}</span>
        <div #pagemap2 style="width:100%;height:600px"></div>
    </div>
</div>